import React, { useState, useEffect } from 'react';
import SidebarLayout from "components/Layout/Layout";
import { API_URL } from "env";
import { Editor } from '@tinymce/tinymce-react';
import { useNavigate } from 'react-router-dom';
import { PencilSimpleIcon, TrashSimpleIcon } from '@phosphor-icons/react'
import { Modal } from "antd";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";

const ListProduct: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [theme, setTheme] = useState("light");
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };
    const clearAllFilters = () => {
        setSearchText('');
    };
    const [searchText, setSearchText] = useState('');
    // const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    // const [showActionModal, setShowActionModal] = useState(false);
    // const [showFormModal, setShowFormModal] = useState(false);
    // const [mode, setMode] = useState<"add" | "edit">("add");

    // const [form, setForm] = useState({
    //     title: "",
    //     type: "",
    //     number: "",
    //     description: "",
    //     is_active: false
    // });
    // List
    const fetchData = async (page = 1, limit = 10) => {
        try {
            setLoading(true);
            let url = `${API_URL}api/v1/be/point_rules?page=${page}&limit=${limit}`;
            if (searchText.trim()) {
                url += `&title=${encodeURIComponent(searchText)}`;
            }
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const json = await response.json();
            setData(json.data.items || []);
            setCurrentPage(json.data.current_page || 1);
            setLastPage(Math.ceil(json.data.total / limit));
        } catch (err) {
            console.error("Lỗi khi gọi API:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage]);
    useEffect(() => {
        setCurrentPage(1);
        fetchData(1);
    }, [ searchText]);
   
    const handleDelete = async (id: number) => {
            Modal.confirm({
                title: "Xác nhận",
                content: "Bạn có chắc muốn xóa mục này không?",
                okText: "Xóa",
                cancelText: "Hủy",
                okButtonProps: { danger: true }, // nút Xóa màu đỏ
                onOk: async () => {
                    try {
                        setLoading(true);
                        const response = await fetch(`${API_URL}api/v1/be/point_rules/${id}`, {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                        });
    
                        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    
                        const json = await response.json();
    
                        if (json.status) {
                            Modal.success({
                                title: "Thành công",
                                content: "Xóa thành công!",
                            });
                        await fetchData(currentPage);
                        } else {
                            Modal.error({
                                title: "Thất bại",
                                content: "Xóa thất bại: " + (json.message || "Unknown error"),
                            });
                        }
                    } catch (error: any) {
                        Modal.error({
                            title: "Lỗi",
                            content: "Lỗi khi xóa: " + error.message,
                        });
                    } finally {
                        setLoading(false);
                    }
                },
            });
        };

    return (
        <SidebarLayout
            title={<h4 className="text-2xl font-bold !m-0 py-4">Points</h4>}
        >
            <div className="table-header-daily">
                <div className="flex items-center gap-10">
                    <h5 className="m-0">List</h5>
                    <div className="relative w-64">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-400">
                        <MagnifyingGlassIcon className="h-5 w-5" />
                        </span>
                        <input
                        type="text"
                        placeholder="Search..."
                        value={searchText}
                        onChange={handleSearchChange}
                        className="w-full pl-8 pr-2 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                        />
                    </div>
                </div>

                
                {(searchText) && (
                    <button
                        className="btn-clear-filters"
                        onClick={clearAllFilters}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Clear Filters
                    </button>
                )}
                <button
                    className="btn-add-daily"
                    onClick={() => navigate('/add-point')}
                >
                    + Add
                </button>
            </div>

            <div className="table-wrapper-daily">
                {loading ? (
                    <p>Đang tải dữ liệu...</p>
                ) : (
                    <>
                        <table className="custom-table-daily">
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>Code</th>
                                    <th>Cooldown Sec</th>
                                    <th>Expires in Days</th>
                                    <th>Max Times Per User</th>
                                    <th>Points</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.id}</td>
                                            <td>{item.code}</td>
                                            <td>{item.cooldown_sec}</td>
                                            <td>{item.expires_in_days}</td>
                                            <td>{item.max_times_per_user}</td>
                                            <td>{item.points_formatted}</td>
                                            <td>
                                                {/* <div className="action-menu-daily" style={{ display: 'flex', gap: '10px' }}>
                                                    <button onClick={() => navigate(`/add-product/edit/${item.id}`)} style={{ backgroundColor: '#1677ff', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Sửa</button>
                                                    <button onClick={() => handleDelete(item.id)} className="delete-btn-daily" style={{ backgroundColor: '#f44336', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Xóa</button>
                                                </div> */}
                                                <div className="action-menu-daily flex gap-2">
                                                    <p
                                                        onClick={() => navigate(`/add-point/edit/${item.id}`)}
                                                        className="cursor-pointer p-2 rounded-[5px] m-0 hover:text-blue-700 hover:bg-blue-200 transition-all duration-500 flex items-center justify-center"
                                                    >
                                                        <PencilSimpleIcon size={18} fill={theme === 'dark' ? '#fff' : ''} />
                                                    </p>
                                                    <p
                                                        onClick={() => handleDelete(item.id)}
                                                        className="cursor-pointer p-2 rounded-[5px] m-0 text-red-700 hover:bg-red-200 transition-all duration-500 flex items-center justify-center"
                                                    >
                                                        <TrashSimpleIcon size={18} fill={theme === 'dark' ? '#fff' : ''} />
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                ))
                                ) : (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: "center" }}>
                                        Không có dữ liệu
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "5px" }}>
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                « Prev
                            </button>
                            {Array.from({ length: lastPage }, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => setCurrentPage(i + 1)}
                                    style={{
                                        fontWeight: currentPage === i + 1 ? "bold" : "normal",
                                        background: currentPage === i + 1 ? "#1677ff" : "white",
                                        color: currentPage === i + 1 ? "white" : "black",
                                        padding: "5px 10px",
                                        border: "1px solid #ccc"
                                    }}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, lastPage))}
                                disabled={currentPage === lastPage}
                            >
                                Next »
                            </button>
                        </div>
                    </>
                    
                    
                )}
            </div>

        </SidebarLayout>
    );
};

export default ListProduct;